'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _darkBaseTheme = require('../baseThemes/darkBaseTheme');

var _darkBaseTheme2 = _interopRequireDefault(_darkBaseTheme);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _darkBaseTheme2.default;

// import deprecatedExport from '../../utils/deprecatedExport';

// export default deprecatedExport(
//   darkBaseTheme,
//   'material-ui/lib/styles/raw-themes/dark-raw-theme',
//   'material-ui/lib/styles/baseThemes/darkBaseTheme'
// );

module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/material-ui/lib/styles/raw-themes/dark-raw-theme.js
// module id = 664
// module chunks = 0